import { SettingsRoutes } from 'pages/settings/route/type'
import { CompliancePath } from 'pages/settings/pages/compliance/route/compliancePath'
import { PersonalPath } from 'pages/settings/pages/personal/route/personalPath'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'
import { UrlShortenerPath } from 'pages/settings/pages/urlShortener/route/urlShortenerPath'

const settings = `${SettingsRoutes.root}`

export const SettingsPath = {
  root: settings,
  compliance: CompliancePath.compliance,
  personal: PersonalPath,
  numbers: NumbersPath,
  urlShortener: UrlShortenerPath,
}
